/*
  PDP C4 (approved prototype, 2026-10-22). Loaded by snippets/joy-kit-upgrade.liquid.

  Kit upgrade (.joy-ku):
  - A card toggles its upgrade on; tapping it again (or the other card) changes or removes it. Nothing chosen =
    the jersey alone, exactly as before.
  - Choosing an upgrade opens its sizes; a size shows that size's add-on price (with the kit price when the item is
    in the offer - the amounts come from the item's variants, written by the snippet).
  - The main Add to cart names the purchase and its total: jersey size price + the upgrade's price.
  - Add to cart with an upgrade but no size: blocked before anything is sent; the card says what is missing.
  - Otherwise the theme (and the product-options app) adds the jersey exactly as today. When the theme reports the
    jersey added (theme:product:add on this button), the upgrade's chosen size is added with POST /cart/add.js and
    the cart drawer is refreshed (theme:cart:refresh). If that second add fails, the line under the button says so.

  Buy box above it (C2 look, no markup of other snippets or apps is changed):
  - "Style" / "Gender Fit" labels get the current choice;
  - the name / team name field of the product-options app is folded into one row until tapped (or filled).
*/
(function () {
  if (window.joyKitUpgradeReady) return;
  window.joyKitUpgradeReady = true;

  function money(cents) {
    var c = Math.round(cents);
    return '$' + (c % 100 === 0 ? (c / 100).toLocaleString('en-US') : (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function init() {
    var dataEl = document.querySelector('[data-joy-ku-jersey] script');
    var jerseyPrices = {};
    try { jerseyPrices = JSON.parse(dataEl.textContent).variants || {}; } catch (e) { /* no data: the kit still works, totals fall back to the theme's price */ }
    var section = (dataEl && dataEl.closest('[data-section-type="product"], .shopify-section')) || document;
    var form = section.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
    var button = form && form.querySelector('[data-add-to-cart]');
    var buttonText = button && button.querySelector('[data-add-to-cart-text]');

    labelChoices(section);
    foldName(section);

    var root = section.querySelector('[data-joy-ku]');
    if (!root || !form || !button) return;

    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-ku-opt]'));
    var stateEl = root.querySelector('[data-ku-state]');
    var chosen = null; // the chosen [data-ku-opt]
    var pending = null; // { id, quantity, name, size } while the theme adds the jersey
    var baseLabel = buttonText ? buttonText.textContent.trim() : 'Add to cart';

    var sub = document.createElement('p');
    sub.className = 'joy-ku-sub';
    sub.hidden = true;
    (form.querySelector('.product__submit') || button.parentNode).appendChild(sub);

    function jerseyPrice() {
      var input = form.querySelector('input[name="id"]');
      var p = input && jerseyPrices[String(input.value)];
      return typeof p === 'number' ? p : null;
    }
    function quantity() {
      var q = form.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    function sizeOf(opt) { return opt.querySelector('[data-ku-variant][aria-checked="true"]'); }
    function low(opt, attr) {
      var vals = Array.prototype.slice.call(opt.querySelectorAll('[data-ku-variant]:not(:disabled)')).map(function (b) { return Number(b.getAttribute(attr)); });
      return Math.min.apply(null, vals);
    }
    function upgrade(opt) {
      var s = sizeOf(opt);
      if (s) return { now: Number(s.getAttribute('data-ku-kit-price')), was: Number(s.getAttribute('data-ku-price')), exact: true };
      return { now: low(opt, 'data-ku-kit-price'), was: low(opt, 'data-ku-price'), exact: false };
    }

    function paintCard(opt) {
      var u = upgrade(opt);
      var now = opt.querySelector('[data-ku-now]');
      if (now) now.textContent = '+' + money(u.now);
      var was = opt.querySelector('[data-ku-was]');
      if (was) was.textContent = money(u.was);
      var from = opt.querySelector('[data-ku-from]');
      if (from) from.hidden = u.exact;
      var s = sizeOf(opt);
      var sv = opt.querySelector('[data-ku-size-value]');
      if (sv) sv.textContent = s ? s.getAttribute('data-ku-size') : '';
    }

    function paintButton() {
      if (!buttonText || button.disabled) return; // sold out / unavailable: the theme's own words stand
      var j = jerseyPrice();
      var label = baseLabel;
      var total = j;
      var from = false;
      if (chosen) {
        var u = upgrade(chosen);
        label = 'Add kit to cart';
        total = j === null ? null : j + u.now;
        from = !u.exact && chosen.querySelectorAll('[data-ku-from]').length > 0;
      }
      var want = esc(label) + (total === null ? '' : '<span class="joy-ku-btn-price"> · ' + (from ? 'from ' : '') + money(total) + '</span>');
      if (buttonText.innerHTML !== want) buttonText.innerHTML = want;
    }

    function paintSub() {
      if (sub.classList.contains('joy-ku-sub--error')) return;
      if (!chosen) { sub.hidden = true; return; }
      var s = sizeOf(chosen);
      var u = upgrade(chosen);
      var sizeInput = section.querySelector('.globo-swatch-product-detail input:checked') || form.querySelector('[data-product-variants] input:checked');
      var jerseySize = sizeInput ? sizeInput.value : '';
      sub.hidden = false;
      sub.innerHTML = (jerseySize ? 'Jersey ' + esc(jerseySize) + ' + ' : 'Jersey + ') + esc(chosen.getAttribute('data-ku-name')) + ' ' +
        (s ? esc(s.getAttribute('data-ku-size')) : '<em>(choose a size)</em>') +
        (u.was > u.now ? ' · <strong>You save ' + money(u.was - u.now) + '</strong>' : '');
    }

    function paint() {
      opts.forEach(function (opt) {
        var on = opt === chosen;
        opt.classList.toggle('is-on', on);
        opt.querySelector('[data-ku-toggle]').setAttribute('aria-pressed', String(on));
        opt.querySelector('[data-ku-more]').hidden = !on;
        paintCard(opt);
      });
      if (stateEl) stateEl.textContent = chosen ? 'Tap again to remove ' + chosen.getAttribute('data-ku-name') + '.' : 'Optional. Skip to buy the jersey on its own.';
      paintButton();
      paintSub();
    }

    function showError(opt, on) {
      var err = opt.querySelector('[data-ku-error]');
      var grid = opt.querySelector('[data-ku-sizes]');
      err.hidden = !on;
      grid.classList.toggle('is-invalid', on);
      if (on) {
        grid.setAttribute('aria-describedby', err.id);
        opt.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var first = grid.querySelector('[data-ku-variant]:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      } else {
        grid.removeAttribute('aria-describedby');
      }
    }

    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ku-toggle]');
      if (toggle) {
        var opt = toggle.closest('[data-ku-opt]');
        if (chosen && chosen !== opt) showError(chosen, false);
        chosen = chosen === opt ? null : opt;
        if (!chosen) showError(opt, false);
        clearSubError();
        paint();
        return;
      }
      var size = e.target.closest('[data-ku-variant]');
      if (size && !size.disabled) {
        var o = size.closest('[data-ku-opt]');
        o.querySelectorAll('[data-ku-variant]').forEach(function (b) { b.setAttribute('aria-checked', String(b === size)); });
        showError(o, false);
        clearSubError();
        paint();
        return;
      }
      if (e.target.closest('[data-ku-chart]')) {
        // The size-chart app's own button (it holds the store's size chart); else the item's own page.
        var chartButton = section.querySelector('#Avada-SC-button .Avada-inline-button, .Avada-inline-button');
        if (chartButton) chartButton.click();
        else window.open(e.target.closest('[data-ku-opt]').getAttribute('data-ku-url'), '_blank', 'noopener');
      }
    });

    function clearSubError() {
      sub.classList.remove('joy-ku-sub--error');
    }

    // Jersey size changed (theme radios or the swatch app): repaint once the form holds the new variant.
    function later() { setTimeout(paint, 0); setTimeout(paint, 250); }
    document.addEventListener('theme:variant:change', later);
    section.addEventListener('change', function (e) { if (!root.contains(e.target)) later(); });
    section.addEventListener('click', function (e) { if (!root.contains(e.target) && e.target.closest('.globo-swatch-product-detail')) later(); });

    // The theme rewrites the button text on variant changes: keep ours (unless sold out).
    if (buttonText) {
      new MutationObserver(function () {
        if (!button.disabled && !/joy-ku-btn-price/.test(buttonText.innerHTML)) {
          baseLabel = buttonText.textContent.trim() || baseLabel;
          paintButton();
        }
      }).observe(buttonText, { childList: true, characterData: true, subtree: true });
    }

    // Before the theme adds: an upgrade without a size stops here. Capture phase on window runs first.
    function guard(e) {
      if (!chosen) { pending = null; return; }
      var s = sizeOf(chosen);
      if (!s) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(chosen, true);
        pending = null;
        return;
      }
      clearSubError();
      pending = { id: Number(s.getAttribute('data-ku-variant')), quantity: quantity(), name: chosen.getAttribute('data-ku-name'), size: s.getAttribute('data-ku-size') };
    }
    window.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-add-to-cart]') === button) guard(e);
    }, true);
    window.addEventListener('submit', function (e) { if (e.target === form) guard(e); }, true);

    // After the theme added the jersey: add the upgrade, then let the theme rebuild the drawer.
    document.addEventListener('theme:product:add', function (e) {
      if (!pending || !e.detail || e.detail.button !== button) return;
      var item = pending;
      pending = null;
      var addUrl = window.theme && theme.routes && theme.routes.cart_add_url ? theme.routes.cart_add_url : '/cart/add';
      if (!/\.js$/.test(addUrl)) addUrl += '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Please try again.');
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch(function (err) {
          sub.hidden = false;
          sub.classList.add('joy-ku-sub--error');
          sub.textContent = 'Your jersey is in the cart, but ' + item.name + ' ' + item.size + ' could not be added. ' + err.message;
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        });
    });
    document.addEventListener('theme:product:add-error', function () { pending = null; });

    paint();
  }

  // "Style: Long Sleeve", "Gender Fit: Men's"
  function labelChoices(scope) {
    var add = function (legend, value) {
      if (!legend || !value || legend.querySelector('.joy-ku-value')) return;
      var span = document.createElement('span');
      span.className = 'joy-ku-value';
      span.textContent = ': ' + value;
      legend.appendChild(span);
    };
    var tile = scope.querySelector('.joy-style__tile-link[aria-current="page"] .joy-style__tile-label');
    add(scope.querySelector('.joy-style__legend'), tile && tile.textContent.trim());
    var fit = scope.querySelector('.joy-fit__option[aria-current="page"]');
    add(scope.querySelector('.joy-fit__legend'), fit && fit.textContent.replace(/\s*Fit\s*$/i, '').trim());
  }

  // Name / team name (product-options app, rendered after load): one row "+ Add your name or team name  FREE".
  // Folds only when the app shows exactly one text field and nothing is typed in it.
  function foldName(scope) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var app = scope.querySelector('gpo-container .gpo-app') || document.querySelector('gpo-container .gpo-app');
      var inputs = app ? app.querySelectorAll('input.gpo-text, textarea, select, input[type="number"], input[type="checkbox"], input[type="radio"]') : [];
      if (!app || !inputs.length) { if (tries > 60) clearInterval(timer); return; }
      clearInterval(timer);
      if (inputs.length !== 1 || !inputs[0].matches('input.gpo-text')) return;
      var input = inputs[0];
      var field = input.closest('.gpo-element') || input.parentNode;
      if (input.value.trim() !== '' || app.querySelector('.joy-ku-name-toggle')) return;
      var label = field.querySelector('.label-content');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'joy-ku-name-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', input.id || '');
      toggle.innerHTML = '<span class="joy-ku-name-toggle__plus" aria-hidden="true">+</span>Add your name or team name<span class="joy-ku-name-toggle__free">Free</span>';
      if (label && !/free/i.test(label.textContent)) toggle.querySelector('.joy-ku-name-toggle__free').remove();
      field.parentNode.insertBefore(toggle, field);
      field.classList.add('joy-ku-name-folded');
      toggle.addEventListener('click', function () {
        field.classList.remove('joy-ku-name-folded');
        toggle.remove();
        input.focus();
      });
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
